<script setup lang="ts">
import { Component } from "../types.ts";

const props = defineProps<{
  item: Component
}>();


</script>

<template>
  <div
    :id="props.item.props.id"
  >
    <slot>

    </slot>
  </div>
</template>
